import { useQuery } from "@apollo/client";
import { type z } from "zod";
import { DocumentUploadForm, type documentUploadFormSchema } from "@/components/DocumentUploadForm";
import { type SelectOption } from "@/components/SelectInput";
import { graphql } from "@/graphql";

interface BookingDocumentUploadFormProps {
  onSubmit: (values: z.infer<typeof documentUploadFormSchema>) => Promise<void>;
  onCancel: () => void;
}

export function BookingDocumentUploadForm({ onSubmit, onCancel }: BookingDocumentUploadFormProps) {
  const { data, loading } = useQuery(supplyChainBookingDocumentTypesQuery, { fetchPolicy: "network-only" });

  const documentTypeOptions: SelectOption[] = (data?.supplyChainBookingDocumentTypes?.edges || [])
    .filter((edge): edge is { node: { id: string; label: string } } => Boolean(edge?.node?.id && edge?.node?.label))
    .map((edge) => ({
      value: edge.node.id,
      label: edge.node.label,
    }));

  return (
    <DocumentUploadForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      documentTypeOptions={documentTypeOptions}
      isLoadingDocumentTypes={loading}
    />
  );
}

export const supplyChainBookingDocumentTypesQuery = graphql(`
  query SupplyChainBookingDocumentTypes {
    supplyChainBookingDocumentTypes {
      edges {
        node {
          id
          label
        }
      }
    }
  }
`);
